import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../Header/Header";
import { useLocation } from "react-router-dom";
import SignatureView from "../../components/SignatureView";
import { postApi } from "../AppApis";
import config from "../../config";
import successImage from "./../../assets/images/HomeInspectorConfirmation.png";
import { toast } from "react-toastify";
import ImagePreviewModal from "../UserDocs/ImagePreviewModal";

export default function CG_SuccessPage() {
    const location = useLocation();
    const { document: document_response, document_id, question_id } = location.state || {};
    const [isSignatureView, setIsSignatureView] = useState(false);
    const [isPDFView, setIsPDFView] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [doc_url, setDoc_url] = useState(document_response?.response?.results[0]?.filled_document_url || "");

    const handleSubmit = async (signature, signValue) => {
        setIsLoading(true);
        let url = "/template-docs/save-pdf/" + document_id;

        try {
            const response = await postApi(url, {
                doc_url: doc_url,
                signature: signature || signValue,
                font_family: signature ? "" : "Helvetica-Bold", // fontfamily only for text
                question_id: question_id,
            });
            toast.success("Signature saved successfully!");
            if (response.doc_url) {
                setDoc_url(response.doc_url);
            } else if (response.error) {
                return alert(response.error);
            }
        } catch (error) {
            console.log("🚀 ~ handleSubmit ~ error:", error);
        } finally {
            setIsLoading(false);
            setIsSignatureView(false);
        }
    };

    const handleDownload = useCallback(async (item) => {
        if (typeof window === "undefined" || typeof document === "undefined") {
            console.warn("Download attempted in a non-browser environment");
            return;
        }

        const path = `https://admin.onmls.com/api${doc_url}`;

        try {
            const authUser = localStorage.getItem("authUser");
            const token = authUser?.replace(/^"|"$/g, "");

            const response = await fetch(path, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch file");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "Filled Document.pdf";
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    }, []);

    return (
        <div className="tw-h-[calc(90vh)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-10  tw-overflow-hidden">
            <Header title="Contract Generation" />
            <div className=" tw-px-[5%] tw-w-fit tw-p-[40px] tw-bg-white tw-rounded-lg tw-flex tw-flex-col tw-text-center tw-h-fit tw-justify-center tw-items-center">
                <img src={successImage} className="tw-w-[200px] tw-mt-5" alt="" />
                <h1 className="tw-text-[30px] tw-font-[700]">Congratulations!</h1>
                <p className="tw-text-[16px] tw-mt-2">You’ve successfully submitted and signed the contract.</p>
                <div className="tw-flex tw-gap-2 tw-w-full tw-items-center tw-justify-center">
                    <button
                        onClick={handleDownload}
                        className="tw-bg-primary hover:tw-bg-primary_hover tw-text-nowrap tw-w-full xl:tw-w-[40%] tw-mt-5 tw-rounded tw-px-5 tw-py-1 tw-text-white tw-text-[16px]"
                    >
                        Download PDF
                    </button>
                    <button
                        onClick={() => setIsPDFView(true)}
                        className="tw-bg-primary hover:tw-bg-primary_hover tw-text-nowrap tw-w-full xl:tw-w-[40%] tw-mt-5 tw-rounded tw-px-5 tw-py-1 tw-text-white tw-text-[16px]"
                    >
                        View PDF
                    </button>
                </div>
            </div>
            {isSignatureView && <SignatureView handleSubmit={handleSubmit} onClose={() => setIsSignatureView(false)} />}
            {isPDFView && (
                <ImagePreviewModal
                    isOpen={isPDFView}
                    isPdf={true}
                    onClose={() => setIsPDFView(false)}
                    imageUrl={"https://admin.onmls.com/api" + doc_url}
                />
            )}
        </div>
    );
}
